export const MESSAGE_ROLES = [
	"Loan Officer",
	"Loan Processor",
	"Broker Admin",
	"TPO Secondary",
	"AE",
	"AM",
	"PA",
];

export const MESSAGE_TYPES = {
	SYSTEM: "login_screen_alert",
	ROLE_SPECIFIC: "role_specific",
	GENERAL: "general_announcement",
};

export const MESSAGE_DRAWER_TYPES = {
	ADD_MESSAGE: "add-message",
	EDIT_MESSAGE: "edit-message",
	MESSAGE_HISTORY: "message-history",
};
